import React from 'react';
import {DOCUMENT_TYPE} from 'utils/constants';
import translate from "../translations/translations.wrapper.jsx";
import * as reduxSelectors from "../store/application.reducers";
import {connect} from "react-redux";
import { RadioButton } from "components/common/RadioButton.component";
import Checkbox from "components/common/checkbox.component";

const RESOLVE_LINES = "resolveOnLines";
const BLOCK_DOCUMENTS = "optional";
const ALLOW_EDIT = "allowEdit";
const REAPPROVE_TYPE = "reapproveType";

export const StepSettings = (props) => {
    let {type, step, translate} = props;

    let changeResolveOnLines = function (event, settingType) {
        event.stopPropagation();
        const isChecked = event.currentTarget.querySelector("input").checked;
        props.changeSetting(settingType, isChecked);
    };
    let changeBlockDocuments = function (event) {
        event.stopPropagation();
        let value = !event.currentTarget.querySelector("input").checked;
        props.changeSetting(BLOCK_DOCUMENTS, value);
    };
    let changeAllowEdit = function (event) {
        event.stopPropagation();
        let value = event.currentTarget.querySelector("input").checked;
        props.changeSetting(ALLOW_EDIT, value);
    };

    const handleCheckboxChange = (settingKey) => (event) => {
        event.stopPropagation();
        const value = event.currentTarget.querySelector("input").checked;
        changeSetting(settingKey, value);
    };

    let changeReapprove = function (event, type) {
        props.changeSetting(REAPPROVE_TYPE, type);
    };

    return (
        <div className="d-flex flex-column mt-4">
            {(type === DOCUMENT_TYPE.INVOICE || type === DOCUMENT_TYPE.VOUCHER || type === DOCUMENT_TYPE.COST_REQUEST || type === DOCUMENT_TYPE.EXPENSE_CLAIM) &&
                <div className={"mb-2"}>
                    <Checkbox
                        inputId={`approve-lines-checkbox${step.stepNumber}`}
                        onChange={(event) => changeResolveOnLines(event, RESOLVE_LINES)}
                        isChecked={step.resolveOnLines}
                        ariaLabel={translate("workflowDetails.approveLines")}
                        label={translate("workflowDetails.approveLines")}
                    />
                </div>
            }

            <div className={"mb-2"}>
                <Checkbox
                    inputId={`workflow-fail-checkbox${step.stepNumber}`}
                    onChange={(event) => changeBlockDocuments(event)}
                    isChecked={!step.optional}
                    ariaLabel={translate("workflowDetails.workflowFail")}
                    label={translate("workflowDetails.workflowFail")}
                />
            </div>

            <Checkbox
                inputId={`allow-edit-checkbox${step.stepNumber}`}
                onChange={(event) => changeResolveOnLines(event,ALLOW_EDIT)}
                isChecked={step.allowEdit}
                ariaLabel={translate("workflowDetails.allowEdit")}
                label={translate("workflowDetails.allowEdit")}
            />

            {
                step.allowEdit &&
                <div className="d-flex flex-column ps-5 gap-8 mt-8">
                    <RadioButton
                        radioId={`always-radio${step.stepNumber}`}
                        isChecked={step.reapproveType === "ALWAYS"}
                        onChange={(e) => changeReapprove(e, "ALWAYS")}
                        label={translate("workflowDetails.always")}
                    ></RadioButton>
                    <RadioButton
                        radioId={`ask-approver-radio${step.stepNumber}`}
                        isChecked={step.reapproveType === "CONFIRMATION"}
                        onChange={(e) => changeReapprove(e, "CONFIRMATION")}
                        label={translate("workflowDetails.ask")}
                    ></RadioButton>
                    <RadioButton
                        radioId={`never-radio${step.stepNumber}`}
                        isChecked={step.reapproveType === "NEVER"}
                        onChange={(e) => changeReapprove(e, "NEVER")}
                        label={translate("workflowDetails.never")}
                    ></RadioButton>
                </div>
            }
        </div>

    )
};

const withTranslations = translate(StepSettings);
const mapStateToProps = function (store) {
    return {
        usersBusinessFeatures: reduxSelectors.getUsersCurrentBusinessFeatures(store)
    };
};
const connected = connect(mapStateToProps, {})(withTranslations);

export default connected;